import { Market } from '../../types/shared/Market';
import { VendorList } from '../../types/shared/Vendor';
import { PlacementByVendor } from '../../types/shared/Placement';
import { Status, AttendanceByMarket } from '../../types/shared/Attendance';

type VendorAttendance = {
  [vendorID: string]: {
    status: Status | void;
    placementIndexes: Array<number>;
  };
};

export default function getVendorAttendance(
  market: Market | null | undefined,
  vendors: VendorList | null | undefined,
  placement: PlacementByVendor | null | undefined,
  date: string | null | undefined,
  attendance: AttendanceByMarket | null | undefined,
): VendorAttendance {
  let attendanceList: VendorAttendance = {};

  if (!market || !vendors || !placement || !date || !attendance) {
    return attendanceList;
  }

  for (let vendorID of Object.keys(placement)) {
    let vendor = vendors.getByID(vendorID);
    if (!vendor || (vendor.markets?.[market.id] || '').indexOf(date) === -1) {
      continue;
    }
    let vendorMarkets = placement[vendorID] || {};
    let vendorDates = vendorMarkets[market.id] || {};
    let placementIndexes = vendorDates[date] || [];

    let attendanceByDate = attendance[market.id] || {};
    let attendanceByVendor = attendanceByDate[date] || {};
    let attendanceStatus = attendanceByVendor[vendor.id];

    // Only return vendor thats assigned to a stall.
    if (placementIndexes.length) {
      attendanceList = {
        ...attendanceList,
        [vendor.id]: {
          status: attendanceStatus,
          placementIndexes,
        },
      };
    }
  }

  return attendanceList;
}
